import { ChevronRight } from "lucide-react";

function BreadcrumbBar({ path, setPath , children }) {
  return (
    <div className="lg:flex flex-wrap justify-between items-center px-0 md:px-4">
    <div className="flex flex-wrap items-center gap-1 md:gap-2 text-sm text-gray-600 mb-2 lg:mb-0">
      {path.map((p, i) => (
        <span key={p} className="flex items-center gap-2">
  {i < path.length - 1 ? (
            <button
              // onClick={() => setPath(path.slice(0, i + 1))}
              className="font-medium hover:underline"
            >
              {/* {p === "Home" ? "The Hindu Today" : p} */}
              {p}
            </button>
          ) : (
            <span className="font-medium">{p}</span>
          )}
          {i < path.length - 1 && (
            <ChevronRight size={16} className="text-gray-400" />
          )}
        </span>
      ))}
    </div>
    {children}
    </div>
  );
}

export default BreadcrumbBar;
